<template>
  
  <div class="table-container">
    <div class="table-scroll">
      <table class="data-table">
        <!-- 多行表头 -->
        <thead>
          <tr>
            <th style="width: 100px;" rowspan="2">Cluster</th>
            <th style="width: 400px;" rowspan="2">Member</th>
            <th style="width: 80px;" rowspan="2">Species count</th>
            <th style="width: 100px;" rowspan="2">%Unreviewed</th>
            <th style="width: 100px;" rowspan="2">TAIR_ID</th>
            <th style="width: 100px;" rowspan="2">RGAP_ID</th>
            <th style="width: 100px;" rowspan="2">Representive</th>
            <th style="width: 50px;" rowspan="2">Length</th>
            <th style="width: 50px;" rowspan="2">PLDDT</th>
            <th style="width: 200px;" colspan="2">TAIR</th>
            <th style="width: 300px;" colspan="2">EGGNOG-mapper</th>
            <th style="width: 500px;" colspan="3">BLAST</th>
            <th style="width: 500px;" colspan="3">FOLDSEEK</th>
          </tr>
          <tr>
            <!-- TAIR 子字段 -->
            <th>Symbol</th>
            <th>Description</th>
            <!-- EGGNOG 子字段 -->
            <th>PFAM</th>
            <th>Description</th>
            <!-- BLAST 子字段 -->
            <th>Subject</th>
            <th>Protein names</th>
            <th>Evalue</th>
            <!-- FOLDSEEK 子字段 -->
            <th>Target</th>
            <th>Protein names</th>
            <th>Alntmscore</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, rowIndex) in tableData" :key="rowIndex">
            <td>{{ item.cluster }}</td>
            <td v-html=item.member></td>
            <td>{{ item.species_count }}</td>
            <td>{{ item.percent_unreviewed }}</td>
            <td v-html=item.tair_id></td>
            <td v-html=item.rgap_id></td>
            <td v-html=item.representive></td>
            <td>{{ item.length || '' }}</td>
            <td>{{ item.plddt || '' }}</td>
            <td>{{ item.symbol || '' }}</td>
            <td>{{ item.description || '' }}</td>
            <td>{{ item.pfam || '' }}</td>
            <td>{{ item.eggnog_description || '' }}</td>
            <td v-html=item.subject></td>
            <td>{{ item.blast_protein_names || '' }}</td>
            <td>{{ item.evalue || '' }}</td>
            <td v-html=item.target></td>
            <td>{{ item.foldseek_protein_names || '' }}</td>
            <td>{{ item.alntmscore || '' }}</td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      loading: false
    };
  },
  watch: {
    '$route.query.q': {
      immediate: true, // 页面首次加载时也会触发
      handler(newQuery) {
        if (newQuery) {
          this.fetchData(newQuery);
        }
      }
    }
  },
  mounted() {
    const q = this.$route.query.q;
    if (q) {
      this.fetchData(q);
    }
  },
  methods: {
    async fetchData(q) {
      this.loading = true;
      try {
        const response = await fetch(`https://ai-biolab.cn/api/search?q=${q}`);
        // const response = await fetch(`http://localhost:3000/api/search?q=${q}`);
        const records = await response.json();
        console.log('检索结果:', records);
        this.tableData = records || [];
      } catch (error) {
        console.error('Failed to fetch table data:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.table-container {
  padding-top: 20px;
}

.table-scroll {
  overflow-x: auto;
  max-width: 100%;
}

.data-table {
  width: 100%;
  table-layout: fixed; /* 🔥 关键 */
  border-collapse: collapse;
}

.data-table th {
  border: 1px solid #ccc;
  padding: 8px 12px;
  text-align: center;
}

.data-table td {
  border: 1px solid #ccc;
  padding: 8px 12px;
  text-align: left;
}

.data-table th {
  background-color: #e6f0ff;
}
</style>
